import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, LOGO_URL } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function AuthCallback() {
  const processed = useRef(false);
  const navigate = useNavigate();
  const { checkAuth } = useAuth();

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    if (!sessionId) {
      navigate("/");
      return;
    }
    (async () => {
      try {
        await api.post("/auth/session", { session_id: sessionId });
        await checkAuth();
      } catch (e) {
        // ignore
      } finally {
        // Clear the hash
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/", { replace: true });
      }
    })();
  }, [checkAuth, navigate]);

  return (
    <div className="loader-veil" data-testid="auth-callback-loader">
      <img src={LOGO_URL} alt="Blisson Professional" className="h-24 md:h-28 w-auto object-contain mix-blend-multiply" />
      <div className="overline mt-6">Signing you in…</div>
      <div className="w-32 h-[2px] mt-6 overflow-hidden bg-black/5">
        <div className="h-full w-full gold-shimmer" />
      </div>
    </div>
  );
}
